let lastScrollTop = 0,
    isScrolling;

$(window)
    .on("scroll", function () {
        const st = $(this).scrollTop();
        $("body")
            .toggleClass("scroll-down", st > lastScrollTop)
            .toggleClass("scroll-up", st <= lastScrollTop)
            .removeClass("scroll-paused");

        lastScrollTop = st;

        clearTimeout(isScrolling);
        isScrolling = setTimeout(
            () => $("body").addClass("scroll-paused"),
            300,
        );
    })
    .trigger("scroll");
